import React from "react";
import { useTranslation } from "react-i18next";
import { getCurrencySymbol } from "../lib/Utils";

export default function UserLockersHistoryComponent({ locker }) {
  const { t } = useTranslation();

  const formatDateTime = (dateString) => {
    if (!dateString) return { date: "", time: "" };

    const date = new Date(dateString);
    if (isNaN(date)) return { date: "", time: "" };

    const datePart = date.toLocaleDateString('en-GB');
    const timePart = date.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });

    return {
      date: datePart,
      time: timePart,
    };
  };

  const checkIn = formatDateTime(locker?.reserve_start);
  const checkOut = formatDateTime(locker?.reserve_end);

  console.log("history locker data:", locker);

  return (
    <div className="locker-card">
      {/* Top Section */}
      <div className="top">
        <div className="title">{locker?.locker_bank_name}</div>
        <div className="status">{locker?.status}</div>
      </div>

      {/* Sub Text */}
      <div className="sub-text">
        {t("locker_size_locker_text", { size: locker?.door_size })}
        <span> {t("door_number_label", { doorNumber: locker?.door_number })}</span>
      </div>

      {/* Date Section */}
      <div className="date-section">
        <div className="date-box">
          <span className="label">{t("check_in_label")}</span>
          <span className="value">{checkIn.date}</span>
          <span className="value">{checkIn.time}</span>
        </div>

        <div className="date-box">
          <span className="label">{t("check_out_label")}</span>
          <span className="value">{checkOut.date}</span>
          <span className="value">{checkOut.time}</span>
        </div>
      </div>

      <hr />

      {/* Total */}
      <div className="total">
        {t("total_label")}: {getCurrencySymbol(locker?.currency)} {locker?.amount}
      </div>
    </div>
  );
}
